/**
 * Route wrapper for the adoption screen.
 *
 * @module Pages/BUs/OptInFeatures
 */

import type { JSX } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { OptInFeatureAdoption } from './Components/OptInFeatureAdoption/OptInFeatureAdoption';
import { useOptInFeature } from './Hooks/useOptInFeature';

export const OptInFeatureAdoptionPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { featureId } = useParams<{ featureId: string }>();

  // Only used to name the screen and show its state, so the page does not wait for it.
  const { data: feature } = useOptInFeature(featureId);

  return (
    <OptInFeatureAdoption
      featureId={featureId ?? ''}
      feature={feature}
      onBack={() => {
        navigate('/opt-in-features');
      }}
    />
  );
};
